<template>
  <div class="col home-news gsap-fade-up">
    <div class="row">
      <div class="col-lg-8" v-if="newsCurrentYear && newsCurrentYear.length">
        <template v-for="(article, index) in newsCurrentYear">
          <router-link :key="article.id"
                       class="component__info-panel"
                       v-if="index == 0"
                       :to="{name: 'page', params: {sectionSlug: 'news', subsectionSlug: 'dernieres-news', pageSlug: article.slug}}">
            <div v-if="article.fields.image && article.fields.image.value" class="bg"
                 :style="{backgroundImage: article.fields.image.value ? 'url('+medium(article.fields.image.value[0])+')' : ''}"></div>
            <div class="content">
              <span class="date"
                    v-if="article.fields.news_date && article.fields.news_date.value">{{ article.fields.news_date.value | dateFormat }}</span>
              <h1 class="title">{{ article.title }}</h1>
              <span class="view-more">En savoir plus</span>
            </div>
          </router-link>
        </template>
      </div>
      <div class="col-lg-4 component__news-list-block">
        <div class="component__news-list" v-if="newsCurrentYear && newsCurrentYear.length">
          <ul>
            <li v-for="(article, index) in newsCurrentYear" v-if="index < 4 && index > 0">
              <router-link
                  :to="{name: 'page', params: {sectionSlug: 'news', subsectionSlug: 'dernieres-news', pageSlug: article.slug}}">
                <div class="img" v-if="article.fields.image.value && article.fields.image.value.length"
                     :style="{backgroundImage: 'url('+thumbnail(article.fields.image.value[0])+')'}"></div>
                <div class="content">
                  <span
                      v-if="article.fields.news_date && article.fields.news_date.value">{{ article.fields.news_date.value | dateFormat }}</span>
                  <h6>{{ article.title }}</h6>
                </div>
              </router-link>
            </li>
          </ul>
          <router-link
              v-if="section.type != 'news'"
              :to="{name: 'SubSection', params: {sectionSlug: newsSection.slug, subsectionSlug: newsSection.children[0].slug}}"
              class="component__news-list__more">Voir plus de news
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _find from 'lodash/find'
import _orderBy from 'lodash/orderBy'
import {mapState} from 'vuex'

export default {
  name: 'Highlight-news-component',
  data() {
    return {
      newsAll: {},
      newsInMonths: {},
      newsCurrentYear: []
    }
  },
  computed: {
    ...mapState({
      sections: 'allSections'
    }),
    newsSection() {
      return _find(this.sections, {type: 'news'});
    },
    section() {
      return _find(this.sections, {slug: this.$route.params.sectionSlug});
    }
  },
  mounted() {
    this.newsOrdering();

  },
  methods: {
    newsOrdering(val) {
      let years = {}

      let dateYear = new Date().getFullYear()
      let newsPages = this.newsSection.collections[0].pages

      // Order by date
      let ordered = _orderBy(newsPages, o => moment(o.fields.news_date.value, 'DD/MM/YYYY').format('YYYY.MM.DD'), ['desc']);

      // Get years for news
      ordered.map(pg => {
        if (pg.fields.news_date && pg.fields.news_date.value) {
          let year = pg.fields.news_date.value.match(/[0-9]{4}/g)[0]
          years[year] = []
          this.newsInMonths[year] = {}
        }
      })

      // Add page in the year
      ordered.map(pg => {
        if (pg.fields.news_date && pg.fields.news_date.value) {
          let date = pg.fields.news_date.value
          let year = date.match(/[0-9]{4}/gi)[0]
          let month = parseInt(moment(date, 'DD/MM/YYYY').format('MM'), 10)

          years[year].push(pg)
          this.newsInMonths[year][month] = []
        }
      })

      // Add news within years
      this.newsAll = years
      // Set current year news
      this.newsCurrentYear = years[dateYear]
      // Pass all news to parent
      this.$emit('allNews', this.newsAll)

      // Add years for news pages withing months of the year
      for (let year in this.newsAll) {
        this.newsAll[year].map(pg => {
          let date = pg.fields.news_date.value
          let month = parseInt(moment(date, 'DD/MM/YYYY').format('MM'), 10)
          this.newsInMonths[year][month].push(pg)
        })
      }

      this.$emit('yearsWithMonths', this.newsInMonths)
      this.$store.commit('newsYears', Object.keys(this.newsInMonths).reverse())
    }
  },
}
</script>
<style></style>